const initialStateCompetencyCategory = {
    competency_category: [],
    competency_category_update: true,
};

export default initialStateCompetencyCategory;